<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'slGrid',
  components: {
  },
  props: {
    async: {
      type: Boolean,
      default: false
    },
    createUrl: {
      type: String
    },
    updateUrl: {
      type: String
    },
    removeUrl: {
      type: String
    },
    data: {
      required: true,
      type: Array
    },
    columns: {
      required: true,
      type: Array
    },
    filterable: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Object,
      validator: function(value) {
        return ['single', 'multiple'].indexOf(value.type) !== -1
      }
    },
    pagination: {
      type: Object
    },
    editable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  mounted () {

  },
  beforeUpdate () {

  },
  data () {
    return { 
      addSlot: false,
      gridData: _.cloneDeep(this.data),
      initialData: [...this.data],
      mirrorData: [...this.data],
      selected: []
    }
  },
  computed: {
    computedColumns () {
      // if (this.editable) {
      //   const newColumns = this.columns.map(column => {
      //     column.dirty = false
      //     return column
      //   })
      // }
      // console.log('this.columns', this.columns)
      return this.columns
    },
    dirtyDataMap () {
      return this.gridData.map((item, index) => {
        return !_.isMatch(this.gridData[index], this.initialData[index])
      })
    },
    // initialData () {
      
    //   return _.cloneDeep(this.data).map(item => {
    //     console.log('item', item);
    //   })
    // },
    newRow () {
      return { }
    }
  },
  methods: {
    exportGrid () {
    },
    refresh () {
    },
    add () {

    },
    confirmAdd () {

    },
    cancelAdd (props) {
      this.addSlot = false
    },
    updateColumn(value, props, col) {
      this.$set(this.gridData[props.row.__index], col.field, value)
    },
    confirmUpdate () {

    },
    clearUpdate (props) {
      this.gridData = _.cloneDeep(this.initialData)
        // const index = props.row.__index
      // _.each(this.gridData[props.row.__index], (gridCol, gridKey) => {
      //   console.log('gridKey', gridKey)
      //   console.log('newVal', this.initialData[index][gridKey])
      //   const newVal = this.initialData[index][gridKey]
      //   const col = props.cols[index]
      //   console.log('init data', this.initialData[index])
      //   this.updateColumn(newVal, props, col)
      //   this.dirtyDataMap[index] = false
      // })
    },
    test (log) {
    }
  }
}
</script>

<template>
  <div>
    <q-table
      row-key="name"
      color="secondary"
      :data="gridData"
      :columns="computedColumns"
      :loading="loading"
      :pagination.sync="pagination"
      :selection="selectable.type"
      :selected.sync="selectable.selected"
    >
      <div id="rowActions" slot="top-left" slot-scope="props" class="row justify-start fit">
        <!-- <q-autocomplete /> -->
        <!-- <q-btn v-if="dirtyDataMap" align="left" color="green" icon="add" @click="addSlot = true"></q-btn> -->
        <div auto-width class="rowButtons" v-if="dirtyDataMap.filter(item => item).length != 0">
          <q-btn class="confirmUpdate" icon="check" color="green" @click="test(dirtyDataMap)"/>
          <q-btn class="cancelUpdate" icon="clear" color="red" @click="clearUpdate(props)" />
        </div>
      </div>
      <div id="gridActions" slot="top-right" slot-scope="props" class="row justify-end fit">
        <div class="row justify-end">
          <q-btn outline rounded color="grey" icon="cached" ref="gridRefresh" align="left" @click="refresh()"></q-btn>&nbsp;
          <q-btn
            outline rounded
            align="left"
            :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'"
            @click="props.toggleFullscreen"
          />&nbsp;
          <q-btn outline rounded align="left" color="primary" icon="archive" @click="exportGrid()"></q-btn>
        </div>
      </div>
      <q-tr slot="header" slot-scope="props">
        
        <!-- <q-th auto-width>
        </q-th> -->
        <q-th id="selectColumnHeader" class="float-left" v-if="props.multipleSelect">
          <!-- {{ selectable.label }}  -->
            <q-checkbox
              class="float-left"
              v-model="props.selected"
              indeterminate-value="some"
            />
        </q-th>
        <q-th id="columnHeaders" class="" auto-width v-for="col in props.cols" :key="col.name" :props="props">
          <span v-if="col.type === Number" class="text-right" > {{ col.label }} </span>
          <span v-else class="text-left"> {{ col.label }} </span>
          <q-td v-if="col.filter" @click.stop class="float-right">
            <div class="row">
              <div class="col-10">
                <q-field>
                  <q-input> </q-input>
                </q-field>
              </div>
              <div id="filterRow" class="col-2">
                <q-btn class="q-mx-md filterButton" icon="filter_list" />
              </div>
            </div>
          </q-td>
              <!-- <div class="row justify-between"  v-if="col.type === 'date'">
                <div class="col-5">
                  <q-datetime  v-model="col.filter.start" type="date" :format="formats.date" :clearable="true" @clear="onFilterClear()" @change="triggerRequest(col.filter.start)"/>
                </div>
                <div>
                  <q-icon class="col-2 vertical-middle" name="remove" size="1.4rem"/>
                </div>
                <div class="col-5">
                  <q-datetime v-model="col.filter.end" type="date" :format="formats.date" :clearable="true" @clear="onFilterClear()" @change="triggerRequest(col.filter.end)"/>
                </div>
              </div>
              <div class="row justify-between" v-if="col.type === 'number'">
                <div class="col-5">
                  <q-input align="left" v-model="col.filter.min" type="number" :clearable="true" @clear="onFilterClear()" @keyup.enter="triggerRequest(col.filter.min)"/>
                </div>
                <div>
                  <q-icon class="col-2 vertical-middle" name="remove" size="1.4rem"/>
                </div>
                <div class="col-5">
                  <q-input align="left" v-model="col.filter.max" type="number" :clearable="true" @clear="onFilterClear()" @keyup.enter="triggerRequest(col.filter.max)"/>
                </div>
              </div>
              <q-input align="left" v-if="col.type === 'string'" :disable="!col.filterable || false" :clearable="true" v-model="col.filter" @clear="onFilterClear()" @keyup.enter="triggerRequest(col.filter)"></q-input>
              <q-select align="left" v-if="col.type === 'state'" :options="stateOptions" :disable="!col.filterable" :clearable="true" v-model="col.filter" @clear="onFilterClear()" @input="triggerRequest(col.filter)"></q-select>
              <q-select align="left" v-if="col.type === 'boolean'" :options="booleanOptions" :disable="!col.filterable" :clearable="true" v-model="col.filter" @clear="onFilterClear()" @input="triggerRequest(col.filter)"></q-select> -->
        </q-th>
      </q-tr>
      <template slot="top-row" slot-scope="props">
        <slot name="add-row" :props="props">
          <q-tr id="addRow" v-if="addSlot" :props="props">
            <q-td auto-width v-if="props.multipleSelect">
            </q-td>
            <!-- <q-td auto-width v-if="dirtyDataMap">
              <q-btn size="sm" class="confirmAdd" icon="check" color="green">
                <q-tooltip> Add </q-tooltip>
              </q-btn>
              <q-btn size="sm" class="cancelAdd" icon="clear" color="red" @click="cancelAdd(props)"/>
            </q-td> -->
            <q-td auto-width v-for="col in props.cols" :key="col.name">
              <!-- <q-input></q-input> -->
            </q-td>
          </q-tr>
        </slot>
      </template>
      <template slot="body" slot-scope="props" >
        <q-tr :props="props" :class="{ dirty: dirtyDataMap[props.row.__index] }">
          <q-td auto-width class="">
            <q-checkbox color="primary" v-model="props.selected" @click="test(props)"/>
          </q-td>
          <!-- <q-td auto-width>
            <div auto-width class="rowButtons" v-if="dirtyDataMap[props.row.__index]">
              <q-btn size="sm" class="confirmUpdate" icon="check" color="green" @click="confirmUpdate(props)"/>
              <q-btn size="sm" class="cancelUpdate" icon="clear" color="red" @click="clearUpdate(props)" />
            </div>
          </q-td> -->
          <q-td v-if="editable || col.editable" v-for="col in props.cols" :key="col.name" :props="props">
            <q-input  v-if="col.type === String" type="text" :value="col.value" @input="(newVal) => updateColumn(newVal, props, col)"/> 
            <q-input  v-if="col.type === Number" type="number" align="right" :value="col.value" @input="(newVal) => updateColumn(newVal, props, col)"/>
            <q-toggle v-if="col.type === Boolean" :value="col.value" color="green" @input="(newVal) => updateColumn(newVal, props, col)" />
          </q-td>
          <q-td v-else>
            <span v-if="col.type === Number" class="float-right">{{ col.value }} </span>
            <span v-else > {{ col.value }} </span>
          </q-td>
          <!-- <q-td v-else>
            <q-toggle readonly v-if="col.type === Boolean" :value="col.value" />
            <p v-else> {{col.value}} </p>
          </q-td> -->
        </q-tr>
      </template>  
    </q-table>
  </div>
</template>

<style scoped>
#selectColumnHeader {
  font-weight: 600;
  color: #000;
  white-space: nowrap;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  border-style: solid;
  border-width: 0;
  padding: 7px 24px;
}
#selectLabel {
  padding: 7px 24px;
  padding-bottom: 5px
}

.q-table-sort-icon-left {
  margin-right: 4px;
}

.dirty {
  background-color: lightyellow
}
.filterButton {
  padding-left: 6px;
  padding-right: 6px;
}

.confirmAdd {
  padding-left: 5px;
  padding-right: 5px;
}

.cancelAdd {
  padding-left: 5px;
  padding-right: 5px;
}

/* .confirmUpdate {
  padding-left: 5px;
  padding-right: 5px;
}

.cancelUpdate {
  padding-left: 5px;
  padding-right: 5px;
} */
</style>